import React from 'react';

import Paper from '@material-ui/core/Paper';

import styles from './index.css';

export class InnerCard extends React.Component {
    render() {
        return (
            <Paper className={styles.root}>{this.props.children}</Paper>
        )
    }
}
